import find from 'lodash/find';
import isArray from 'lodash/isArray';
import extend from 'lodash/extend';
import isUndefined from 'lodash/isUndefined';
import StructureContainersStorage from '@Services/AppDBStorage/Storages/StructureContainersStorage';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';

export const generateUID = () => `uid-${StructureContainersStorage.uniqId()}`;

export const saveContainer = async (structureUID, structureContainer) => StructureContainersStorage.set(structureUID, structureContainer);

export const updateContainer = async (structureUID, structureContainer) => {
  try {
    const savedContainer = await StructureContainersStorage.get(structureUID);
    extend(savedContainer, structureContainer);
    return StructureContainersStorage.set(structureUID, savedContainer);
  } catch (e) {
    Logger.reject(e);
    return undefined;
  }
};

export const getContainerByUID = async (structureUID) => StructureContainersStorage.get(structureUID);

export const getContainerOptions = async (structureUID) => {
  try {
    const container = await getContainerByUID(structureUID);
    return container.options || [];
  } catch (e) {
    Logger.reject(e);
    return undefined;
  }
};

export const updateContainerOptions = async (structureUID, options, optionsState) => {
  if (!structureUID) {
    Logger.warn('updateContainerOptions: structureUID is undefined, skipping');
    return;
  }

  try {
    const container = await getContainerByUID(structureUID);

    // Only update if container exists AND has structure data
    if (!container || !container.data) {
      return;
    }
    if (!isUndefined(options)) {
      container.options = options;
    }
    if (!isUndefined(optionsState)) {
      container.optionsState = optionsState;
    }
    await saveContainer(structureUID, container);
  } catch (e) {
    Logger.reject(e);
  }
};

// eslint-disable-next-line consistent-return
export const updateStructureWithDisabledOptions = async (query, uid) => {
  try {
    const options = await getContainerOptions(uid);
    if (options) {
      const fact = find(query.facts, ({ structures }) => structures);
      if (fact && isArray(fact.structures)) {
        fact.structures[0].options = options;
      }
    }
    return history.push({
      pathname: paths.ADVANCED,
      state: { importedQuery: query },
    });
  } catch (e) {
    Logger.error(e);
  }
};

export const removeContainerByUID = async (structureUID) => StructureContainersStorage.remove(structureUID);

export const removeContainersByUIDs = async (structureUIDs) =>
  Promise.all(structureUIDs.map((uid) => StructureContainersStorage.remove(uid)));

export const removeAllContainers = async () => StructureContainersStorage.clear();
